/* eslint-disable */
import { FC } from 'react';
import styles from '../../styles/components/controlVariations/ConfirmDownloadModal.module.css';
import TickMarkSuccess from '../../assets/icons/TickMarkSuccess.png';

const SuccessContent: FC = () => {
	return (
		<div className={styles.modal}>
			<div className={styles.iconWrapper}>
				<img src={TickMarkSuccess} alt="Success" />
			</div>

			<h2 className={styles.title}>Assignment Submitted Successfully</h2>
		</div>
	);
};

export default SuccessContent;
